export default __webpack_public_path__ + "static/media/factory.ffde60d8.svg";